import { FC, useEffect, useState } from 'react';


import RichText from '@eneco/components/RichText/RichText';
import { TrackedNotificationBox } from '@eneco/components/TrackedNotificationBox/TrackedNotificationBox';
import { useTranslation } from '@eneco/i18n';
import { Usages_Reading_CounterModel } from '@monorepo-types/dc';
import { Control, useForm, useWatch } from 'react-hook-form';
import { useDebounce } from 'react-use';

import { FormValues } from '../MeterReadingStep';

export const DeviationNotification: FC<{
  counter: Usages_Reading_CounterModel;
  control: Control<FormValues>;
  denotation: string;
}> = ({ control, counter, denotation }) => {
  const { t } = useTranslation();
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const { formState } = useForm();
  const { counters } = useWatch<FormValues>({ control });
  const counterValue = counters?.[counter.counterIdentification];
  const deviation = !!counterValue && (counterValue < counter.lowBoundary || counterValue > counter.highBoundary);

  useEffect(() => {
    if (formState.isSubmitting) setShowNotification(false);
  }, [formState.isSubmitting, setShowNotification]);

  useDebounce(
    () => {
      setShowNotification(deviation);
    },
    1000,
    [deviation, counterValue],
  );

  if (!showNotification || !deviation) return null;

  const deviationType = counterValue > counter.highBoundary ? 'higher' : 'lower';
  const content = t(`readingDeviationNotification.${deviationType}Content`, {
    name: counter.name || '',
    lowBoundary: counter.lowBoundary,
    highBoundary: counter.highBoundary,
    denotation,
  });

  return (
    <TrackedNotificationBox
      isAlert={false}
      label={`deviation notification ${deviationType}`}
      variant="info"
      text={<RichText html={content} />}
    />
  );
};
